// components
import EyedropperHollow from "core/ReusableIcons/EyedropperHollow.js";
import Apps from "core/ReusableIcons/Apps.js";
import PieceOfPie from "core/ReusableIcons/PieceOfPie.js";

// styles
import colors from "core/colors";

export const promos = [
    {
        id: 1,
        title: `Mac App for Icons`,
        text: `Drag and drop icons from the Mac app into any program. <span class="faux-link">Get app</span>`,
        href: `/for-mac/`,
        target: `_self`,
        Icon: Apps,
        iconSize: 44
    },
    {
        id: 2,
        title: `PowerPoint Add-In`,
        text: `Find and edit icons without leaving PowerPoint or Office. <span class="faux-link">Try it out</span>`,
        href: `/for-office/`,
        target: `_self`,
        Icon: PieceOfPie,
        iconSize: 30
    },
    {
        id: 3,
        title: `Easy Icon Editor`,
        text: `Recolor, rotate, and add effects with a click. <span class="faux-link">Available on all icons</span>`,
        href: `/icon/try-out-our-easy-icon-editor-7928132/`,
        target: `_self`,
        Icon: EyedropperHollow,
        iconSize: 25
    }
];

export const getLightDarkProps = isDarkMode => {
    let fontColor = colors.secondary.orca;
    let borderColor = colors.primary.scheifer;
    let borderHoverColor = colors.secondary.orca;
    let linkColor = colors.accent.lightMode.persian;
    let linkHoverColor = colors.accent.lightMode.pansy;

    if (isDarkMode) {
        fontColor = colors.primary.diamond;
        borderColor = colors.secondary.basalt;
        borderHoverColor = colors.primary.diamond;
        linkColor = colors.accent.darkMode.suenosBuenos;
        linkHoverColor = colors.accent.darkMode.surf;
    }

    return {
        fontColor,
        borderColor,
        borderHoverColor,
        linkColor,
        linkHoverColor
    };
};
